import React from 'react';
import { Link } from 'react-router-dom';
import { Package } from 'lucide-react';

// Tiles de categorias pra home do storefront. Cada tile leva pro catálogo
// pré-filtrado. Quando a categoria não tem imagem, mostra placeholder com
// inicial colorida (mesmo padrão da logo da loja).
const TILE_COLORS = [
  'from-primary to-primary-dark',
  'from-secondary to-secondary-dark',
  'from-accent to-primary',
  'from-primary-light to-primary',
];

const CategoryTiles = ({ categories = [], limit = 12 }) => {
  if (!categories || categories.length === 0) return null;
  // Apenas categorias raiz (nível 1) — sub-níveis ficam disponíveis no aside
  // de filtros do catálogo (drill-down) e na mega-menu da CategoryNavBar.
  const roots = categories.filter((c) => !c.parentId);
  const visible = roots.slice(0, limit);
  if (visible.length === 0) return null;

  return (
    <section className="my-6">
      <h2 className="text-lg md:text-xl font-bold text-app-text mb-3">
        Categorias
      </h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2">
        {visible.map((cat, i) => (
          <Link
            key={cat.id}
            to={`/catalogo?categoryId=${cat.id}`}
            className="group flex flex-col items-center text-center gap-1.5 p-2 rounded-md hover:bg-app-surface-hover transition-colors"
          >
            {cat.imageUrl ? (
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden bg-app-surface ring-1 ring-app-border group-hover:ring-primary transition-all">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
            ) : (
              <div
                className={`w-14 h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-br ${TILE_COLORS[i % TILE_COLORS.length]} flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow`}
              >
                <Package size={20} className="text-white/70" />
              </div>
            )}
            <span className="text-xs font-medium text-app-text line-clamp-2 group-hover:text-primary transition-colors">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CategoryTiles;
